export const contacts: any = {
    "ESA/ESS": [
        {
            name: "Giuseppe Parrella",
            post: "Service Manager & Technical Officer",
            email: "Giuseppe.Parrella@esa.int",
            phone: "+39 06 941 80 321"
        },
        {
            name: "Paolo Boezi",
            post: "Deputy of the Service Manager\nESS Project Coordinator",
            email: "paolo.boezi@cs-soprasteria.com",
        },
        {
            name: "Claudia Neroni",
            post: "Service Coordination Support",
            email: "claudia.neroni@cs-soprasteria.com",
        },
        {
            name: "Domenico Castrovillari",
            post: "Data Librarian",
            email: "d.castrovillari@cs-soprasteria.com",
        },
        {
            name: "Gianluca Colamussi",
            post: "ESS Project Coordinator",
            email: "gianluca.colamussi@serco.com",
        },
        {
            name: "Manuel Nardelli",
            post: "Network and security expert",
            email: "manuel.nardelli@cs-soprasteria.com",
        },
    ],
    "ACRI-ST": [
        {
            name: "Olivia Lesne",
            post: "Service Manager & Issue Manager",
            email: "olivia.lesne@acri-st.fr",
            phone: "+33 (0)4 92 96 29 11"
        },
        {
            name: "Gilbert Barrot",
            post: "Deputy of the Service Manager - Deputy of the Data and Configuration Manager ",
            email: "gilbert.barrot@acri-st.fr",
            phone: "+33 (0)4 92 96 75 04"
        },
        {
            name: "Olivier Sardou",
            post: "Deputy of the Issue Manager & Data and Configuration Manager",
            email: "olivier.sardou@acri-st.fr",
            phone: "+33 (0)4 92 96 71 16"
        },
        {
            name: "Gaston Briot",
            post: "Data archival and related services manager",
            email: "gaston.briot@acri-st.fr",
            phone: "+352 26 71 04 64"
        },
        {
            name: "Stéphane Clouaire",
            post: "Deputy of the Infrastructure and Security Manager",
            email: "stephane.clouaire@acri-st.fr",
            phone: "+33 (0)4 92 96 75 02"
        },
    ],
    "adwäisEO": [
        {
            name: "Giovanni Corato",
            post: "Infrastructure and Security Manager",
            email: "giovanni.corato@adwaiseo.eu",
            phone: "+352 26 71 04 64"
        },
        {
            name: "Frédéric Twahirwa",
            post: "Data ingestion Service Manager ",
            email: "frederic.twahirwa@adwaiseo.eu",
            phone: "+352 26 71 04 64"
        },

    ],
    "Serco": [
        {
            name: "Alessandra Paciucci",
            post: "Bulk processing and Data consolidation Project Pilot",
            email: "Alessandra.Paciucci@serco.com"
        },
        {
            name: "Salvatore Papaleo",
            post: "DIS Service Manager",
            email: "Salvatore.Papaleo@serco.com"
        }
    ],
    "ARGANS": [
        {
            name: "Steve Emsley",
            post: "Processing System Integration Project Pilot",
            email: "SEmsley@argans.co.uk",
        },
    ],
    "KSAT": [
        {
            name: "Mai-Eli Johansen",
            post: "Bulk ingestion verification and validation",
            email: "maieli@ksat.no"
        }
    ]
}


export const maintenance_contacts: any = {
    "recipients": [
        {
            email: "antonio.de.la.fuente@esa.int"
        },
        {
            name: "Roberto Alacevich",
            email: "Roberto.Alacevich@esa.int"
        },
        {
            name: "Giuseppe Parrella",
            email: "giuseppe.parrella@esa.int"
        },
        {
            email: "Roberto.Biasutti@esa.int"
        },
        {
            name: "Cristiano Lopes",
            email: "Cristiano.Lopes@esa.int"
        },
        {
            email: "Raffaele.Grimaldi@esa.int"
        }
    ],
    "copy_to": [
        {
            name: "Torroni, Vittorio",
            email: "vittorio.torroni@serco.com"
        },
        {
            email: "eoeng@serco.com"
        },
        {
            email: "francesca.gabrieli@ext.esa.int"
        },
        {
            email: "dpgs-operations@smos.eo.esa.int"
        },
        {
            email: "TPM-PDGS-Coordination@esa.int"
        },
        {
            email: "alessandro.maltese@ext.esa.int"
        },
        {
            email: "andrea.schedid@ext.esa.int"
        },
        {
            name: "Paolo Boezi",
            email: "paolo.boezi@cs-soprasteria.com"
        },
        {
            name: "Domenico Castrovillari",
            email: "d.castrovillari@cs-soprasteria.com"
        },
        {
            email: "Aeolus-pdgs-coordination@esa.int"
        },
        {
            name: "Gianluca Colamussi",
            email: "gianluca.colamussi@serco.com"
        },
        {
            name: "ADWAISEO # Production Team",
            email: "op_team@adwaiseo.eu"
        },
        {
            name: "ADWAISEO # Service IT",
            email: "dpt.it@adwaiseo.eu"
        },
        {
            name: "Olivia Lesne",
            email: "olivia.lesne@acri-st.fr"
        },
        {
            name: "Olivier Sardou",
            email: "olivier.sardou@acri-st.fr"
        },
        {
            email: "EarthCARE-pdgs-coordination@esa.int"
        }
    ]
}